import { FormControl, createStyles, makeStyles } from '@material-ui/core';
import { FC } from 'react';
import styles from '../styles';

const AuthForm: FC = ({ children }) => {
  const { formControl } = makeStyles((theme) => createStyles(styles(theme)))();
  return <FormControl className={formControl}>{children}</FormControl>;
};

export default AuthForm;
